import { BarsStaggeredIcon, Button, useMemoizeArg } from "@r360/library";
import React, { useEffect, useState } from "react";
import useTranslate from "../../hooks/useTranslate";
import useReservationTypeCriterias from "../../hooks/useReservationTypeCriterias";
import useAppSelector from "../../hooks/useAppSelector";
import { ECriteriaPresentationType, TReservationResult } from "../../store/types";
import { RootState } from "../..";

type TToggleFilterButton = {
    reservationTypeId: number;
    showFilter: boolean;
    onClick: (arg0: boolean) => void;
};

export const ToggleFilterButton = ({ reservationTypeId, showFilter, onClick }: TToggleFilterButton) => {
    const t = useTranslate();
    const filters = useAppSelector(state => state.filter);
    const reservationResults = useAppSelector((state: RootState) => state.reservationResult);
    const reservationResult: TReservationResult | undefined = reservationResults?.[reservationTypeId];
    const channellid = reservationResult?.search?.channellid || 0;
    const reservationTypeCriterias = useReservationTypeCriterias(reservationTypeId, channellid);
    const activeFilters = filters && reservationTypeId in filters ? filters[reservationTypeId] : {};
    const [activeFiltersCount, setActiveFiltersCount] = useState(0);

    useEffect(() => {
        // Filter out activeFilters not in reservationTypeCriterias.
        const allowedCriteriaCodes = Object.entries(reservationTypeCriterias ?? {})
            .filter(([key]) => {
                return [
                    ECriteriaPresentationType.INTERVAL_FILTERS,
                    ECriteriaPresentationType.ACCOMMODATION_TYPE_FILTERS,
                    ECriteriaPresentationType.ENUM_FILTERS,
                    ECriteriaPresentationType.AMENITIES_FILTERS,
                    ECriteriaPresentationType.OTHER_FILTERS,
                ].includes(key as ECriteriaPresentationType);
            })
            .flatMap(([, value]) => value)
            .map(item => item.code);

        const activeFiltersCount = Object.keys(activeFilters ?? {}).filter(critcode =>
            allowedCriteriaCodes?.includes(parseInt(critcode, 10))
        ).length;
        if (activeFiltersCount) {
            setActiveFiltersCount(activeFiltersCount);
        } else {
            setActiveFiltersCount(0);
        }
    }, [useMemoizeArg(activeFilters), reservationTypeCriterias]);

    return (
        <Button
            type="secondary"
            buttonSize="small"
            leftIcon={<BarsStaggeredIcon />}
            onClick={() => onClick(!showFilter)}
        >
            {showFilter
                ? `${t("book.general.hide_filter")} (${activeFiltersCount})`
                : `${t("book.general.show_filter")} (${activeFiltersCount})`}
        </Button>
    );
};
